<template>
    <div class="sign" id="sign-with-bankid">
      <h2 class="sign__title" v-if="$root.sign.requestType === 'BankID'">Bank ID</h2>
      <h2 class="sign__title" v-else>Mobilt BankID</h2>
      <div id="sign__qrcode" class="sign__qrcode"></div>
      <div class="sign__step step-02" v-if="$root.sign.step === 1">
          <p v-html="$root.sign.message"></p>
        <div class="sign__loader"><img src="@/assets/images/svg-loaders/spinning-circles.svg" width="21" alt="Laddar" /></div>
        <div class="cancel" v-on:click="cancel()">Avbryt och återgå</div>
      </div>
      <div class="sign__step step-03" v-if="$root.sign.step === 2">
        <p v-html="$root.sign.message"></p>
        <div class="sign__loader"><img src="@/assets/images/svg-loaders/spinning-circles.svg" width="21" alt="Laddar" /></div>
        <div class="cancel" v-on:click="cancel()">Avbryt och återgå</div>
      </div>
      <div class="sign__step step-04" v-if="$root.sign.step === 3">
          <p>Var god vänta. Skickar uppgifter för godkännande till Borås Elhandel.</p>
          <div class="sign__loader"><img src="@/assets/images/svg-loaders/spinning-circles.svg" width="21" alt="Laddar" /></div>
      </div>
    </div>
  </template>
  <script>

      import axios from 'axios';
      export default {
          created() {
              let curThis = this;
              //if(!this.$root.final_price)
                  //this.$router.push({ name: 'kund' })
                  //alert('Kör signering?');
                  setTimeout(function () {

                    if (curThis.$root.isProduction) {
                      curThis.sign();
                    } else {
                      curThis.fakeSign();
                    }
                  }, 100);
          },
          methods: {
              sign() {
                  // Removed because it didn't work on production?
                  /*
                  if (process.env.VUE_APP_skip_bankid) {
                      this.$root.sign.step = 4;
                      this.send();
                      return;
                  }*/
                  var ssn = this.$root.validatePersonnummer(this.$root.personnummer);
                  this.$root.sign.ssn = ssn;
                  if(ssn) {
                      this.$root.feedback.ssn = false; // hide feedback for ssn
                      this.$root.sign.step = 1;


                      let curThis = this;
  
                      fetch(this.$root.publicUrl + '/api/bankid.php?api=sign&ssn=' + this.$root.sign.ssn + '&requestType=' + this.$root.sign.requestType).then(r => r.json()).then(r => {
                        if (r != null && r.success) {
                            curThis.$root.sign.step = 2;
                            curThis.$root.sign.transactionId = r.transactionId;
                            curThis.$root.sign.autoStartToken = r.autoStartToken;

                            if (curThis.$root.sign.qrCode != r.qrCode) {
                              curThis.$root.sign.qrCode = r.qrCode;
                              document.getElementById('sign__qrcode').innerHTML = curThis.$root.generateQrCodeImgTag(curThis.$root.sign.qrCode);
                            }

                            setTimeout (function () {
                              curThis.collect();
                            }, 1000);
                          } else {
                            curThis.$root.sign.step = 1;
                              console.log('error');
                              document.getElementById('sign__qrcode').innerHTML = '';
                          }
                      });

                        /*setTimeout(function () {
                          let r = {
                            success: true,
                            transactionId: 'EXAMPLE123',
                            autoStartToken: 'EXAMPLE321'
                          };
                          if (r.success) {
                            curThis.$root.sign.step = 2;
                            curThis.$root.sign.transactionId = r.transactionId;
                            curThis.$root.sign.autoStartToken = r.autoStartToken;
                            curThis.collect();
                          } else {
                            curThis.$root.sign.step = 1;
                              console.log('error');
                          }
                      }, 100);*/

                  } else {
                    alert("Error! Inget personnummer");
                  }
              },
              collect() {

                  let curThis = this;
                  fetch(this.$root.publicUrl + '/api/bankid.php?api=collect&transactionId='+this.$root.sign.transactionId+'&ssn=' + this.$root.sign.ssn + '&requestType=' + this.$root.sign.requestType).then(r => r.json()).then(r => {
                    //setTimeout(function() {
                      //let r = {
                        //status: 'COMPLETE'
                      //};

                      if (curThis.$root.sign.qrCode != r.qrCode) {
                        curThis.$root.sign.qrCode = r.qrCode;
                        document.getElementById('sign__qrcode').innerHTML = curThis.$root.generateQrCodeImgTag(curThis.$root.sign.qrCode);
                      }

                      var self = curThis;
                      switch(r.status.toUpperCase()) {
                          case 'COMPLETE':

                          curThis.$root.sign.step = 3;
                          curThis.send();
                              break;
                          case 'USER_SIGN':
                          curThis.$root.sign.message = 'Skriv in säkerhetskoden i BankID-programmet.';
                              if(curThis.$root.sign.step===2){
                                  setTimeout(function() {
                                      self.collect();
                                  }, 200);
                              }
                              break;
                          case "NO_CLIENT":
                          curThis.$root.sign.message = '<a href="bankid:///?autostarttoken='+curThis.$root.sign.autoStartToken+'&redirect=">Starta BankID säkerhetsprogram</a>';
                              break;
                          case "USER_CANCEL":
                          curThis.cancel();
                              break;
                          default:
                          curThis.$root.sign.collect ++;
  
                              if(curThis.$root.sign.requestType === 'MobileBankID')
                              curThis.$root.sign.message = 'Starta BankID-appen på din mobiltelefon eller surfplatta.';
  
                              if(curThis.$root.sign.requestType === 'BankID') {
                                curThis.$root.sign.message = 'Försöker starta BankID-programmet.';
                                  if(curThis.$root.sign.collect>50) {
                                    curThis.$root.sign.message = '<a href="bankid:///?autostarttoken='+curThis.$root.sign.autoStartToken+'&redirect=">Starta BankID säkerhetsprogram</a>';
                                  }
                              }
  
                              if(curThis.$root.sign.step===2){
                                  setTimeout(function() {
                                      self.collect();
                                  }, 200);
                              }
                      }
                  }/*, 100*/);
              },
              fakeSign() {
                  // Removed because it didn't work on production?
                  /*
                  if (process.env.VUE_APP_skip_bankid) {
                      this.$root.sign.step = 4;
                      this.send();
                      return;
                  }*/
                  var ssn = this.$root.validatePersonnummer(this.$root.personnummer);
                  this.$root.sign.ssn = ssn;
                  if(ssn) {
                      this.$root.feedback.ssn = false; // hide feedback for ssn
                      this.$root.sign.step = 1;


                      let curThis = this;
                      setTimeout(function () {
                          let r = {
                            success: true,
                            transactionId: 'EXAMPLE123',
                            autoStartToken: 'EXAMPLE321'
                          };
                          if (r.success) {
                            curThis.$root.sign.step = 2;
                            curThis.$root.sign.transactionId = r.transactionId;
                            curThis.$root.sign.autoStartToken = r.autoStartToken;
                            curThis.fakeCollect();
                          } else {
                            curThis.$root.sign.step = 1;
                              console.log('error');
                          }
                      }, 100);

                  } else {
                    alert("Error! Inget personnummer");
                  }
              },              
              fakeCollect() {
                  let curThis = this;
                  setTimeout (function () {
                    curThis.$root.sign.step = 3;
                    curThis.send();
                  }, 100);
              },              
              cancel(){
                  this.$root.sign.transactionId = null;
                  this.$root.sign.autoStartToken = null;
                  this.$root.sign.ssn = null;
                  this.$root.sign.status = 'idle';
                  this.$root.sign.step = 1;
                  this.$root.sign.collect = 0;
                  document.getElementById('sign__qrcode').innerHTML = '';
              },
              send(){
                  document.getElementById('sign__qrcode').innerHTML = '';
                  this.$root.summary.price = this.$root.price;
                  this.$root.summary.final_price = this.$root.final_price;
                  this.$root.summary.price_total = this.$root.getTotalFixedPrice(this.$root.watts);
  
                  if(this.$root.price_type==='mix5050') {
                      this.$root.summary.price_el_fixed = this.$root.fixed_months_contract(12).price;
                      this.$root.summary.price_el_movable = this.$root.round_value(this.$root.movable_contract().price);
                      this.$root.summary.price_el_cert = this.$root.round_value(this.$root.movable_contract().elCert);
                      this.$root.summary.price_el_addon = this.$root.round_value(this.$root.movable_contract().addon);
                      this.$root.summary.price_el_vat = this.$root.getVATMix5050();
                      this.$root.summary.monthly_fee = this.$root.round_value(this.$root.movable_contract().monthlyFee);
                      this.$root.summary.price_total = this.$root.getTotalMix5050Price(this.$root.watts, true);
                  }
                  else if(this.$root.price_type==='variable') {
                      this.$root.summary.price_total = this.$root.getTotalVariablePrice(this.$root.watts, true);
                      this.$root.summary.price_raw = this.$root.round_value(this.$root.movable_contract().price);
                      this.$root.summary.price_el = this.$root.round_value((this.$root.movable_contract().elCert + this.$root.movable_contract().addon + this.$root.movable_contract().price) * 1.25);
                      this.$root.summary.monthly_fee = this.$root.round_value(this.$root.movable_contract().monthlyFee);
                      this.$root.summary.price_el_purchasecost = 0;
                      this.$root.summary.price_el_cert = this.$root.movable_contract().elCert;
                      this.$root.summary.price_el_addon = this.$root.movable_contract().addon;
                      this.$root.summary.price_el_vat = this.$root.round_value((this.$root.movable_contract().elCert + this.$root.movable_contract().addon + this.$root.movable_contract().price)*.25);
                  }
                  else if(this.$root.price_type==='spotavtal') {
                      this.$root.summary.price_total = this.$root.getTotalSpotPrice(this.$root.watts, true);
                      this.$root.summary.price_raw = this.$root.round_value(this.$root.timspot_contract().price);
                      this.$root.summary.price_el = this.$root.round_value((this.$root.timspot_contract().purchaseCost + this.$root.timspot_contract().elCert + this.$root.timspot_contract().addon + this.$root.timspot_contract().price) * 1.25);
                      this.$root.summary.monthly_fee = this.$root.round_value(this.$root.timspot_contract().monthlyFee);
                      this.$root.summary.price_el_purchasecost = this.$root.timspot_contract().purchaseCost;
                      this.$root.summary.price_el_cert = this.$root.timspot_contract().elCert;
                      this.$root.summary.price_el_addon = this.$root.timspot_contract().addon;
                      this.$root.summary.price_el_vat = this.$root.round_value((this.$root.timspot_contract().purchaseCost + this.$root.timspot_contract().elCert + this.$root.timspot_contract().addon + this.$root.timspot_contract().price)*.25);
                  }
                  else if(this.$root.price_type==='fixed') {
                    this.$root.summary.price_total = this.$root.getTotalFixedPrice(this.$root.watts, true);
                    this.$root.summary.price_el = this.$root.round_value(this.$root.fixed_contract().price*1.25);
                    this.$root.summary.monthly_fee = this.$root.round_value(this.$root.fixed_contract().monthlyFee);
                    this.$root.summary.price_el_vat = this.$root.round_value(this.$root.fixed_contract().price*.25);
                    this.$root.summary.price_raw = this.$root.round_value(this.$root.fixed_contract().price);
                  }

                  axios.post(this.$root.publicUrl + "/api/mailv2.php", JSON.stringify(this.$root.$data))
                      .then(function (response) {
                          if(response.data.message == "ok") {
                            /*
                              curThis.$gtag.query('event', 'contractservice_finished', {
                                  'event_callback': function() {
                                  //console.log("event sent");
                                  }
                              });
                              */
                              window.location.replace("https://www.boraselhandel.se/tacksida/");
                          } else {
                              alert ("Något fel inträffade!");
                          }
                  });
              },
          },
      }
  </script>
  <style lang="scss">
    .sign {
      &__qrcode {
        display: block;
        clear: both;
        text-align: center;
        width: 100%;
      }
      &__title {
        text-align: center;
        margin: 0;
        @include font-primary(bold);
      }
      &__subtitle {
        text-align: center;
        @include font-primary(roman);
        margin: 0 0 rem(22);
        font-size: rem(16);
      }
      &__field-wrapper {
        margin-bottom: rem(24);
        font-size: rem(16);
        display: block;
      }
      &__field-group {
        @include media('>lg') {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
        }
      }
      &__lookup {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
      }
      &__field-group &__field-wrapper {
        @include media('>lg') {
          flex-basis: calc(50% - #{rem(12)});
        }
      }
      &__lookup &__field-wrapper {
        flex-basis: calc(50% - #{rem(12)});
      }
      &__field {
        @include unstyled-text-field;
        display: block;
        width: 100%;
        border: 1px solid $light-border-color;
        padding: #{(13/18)}em;
        &:focus,
        &:hover {
          border-color: $dark-border-color;
        }
        &::placeholder {
          color: $dark-border-color;
        }
      }
      &__field-label {
        @include font-primary;
        color: $secondary-text-color;
        margin: 0 0 rem(6);
        display: block;
        &--title {
          @include font-primary(bold);
          color: $secondary-text-color;
          font-size: rem(18);
          display: block;
          margin: 0 0 rem(9);
        }
        em {
          font-style: normal;
          color: #c00;
        }
      }
      &__lookup-submit {
        flex: 1 1;
        margin: 0 0 rem(24) rem(24);
        font-size: rem(16);
      }
      &__step {
        &.step-02 {
          font-size: 16px;
          text-align: center;
          padding-top: 80px;
        }
        &.step-03 {
          font-size: 16px;
          text-align: center;
          padding-top: 80px;
        }
        &.step-04 {
          font-size: 16px;
          text-align: center;
          padding-top: 80px;
        }
        .cancel {
          color: $primary-color;
          cursor: pointer;
          text-decoration: underline;
        }
      }
      &__loader {
        width: 21px;
        margin: 20px auto;
        text-align: center;
      }
    }
  </style>
  